'use client'
import React, { useEffect } from 'react'
import HeroSection from './components/HeroSection'
import WeDeliverBigger from './components/WeDeliverBigger'
import {
   ContactUsForm,
   DefinesUsSection,
   TechnologiesList,
   WordsOfAppreciation,
} from '@/components'
import ClientsPartnersSection from './components/ClientsPartnersSection'
import WhyChooseUs from './components/WhyChooseUs'
import BlogSection from './components/BlogSection'

export default function HomePage() {
   return (
      <div>
         <HeroSection />
         <WeDeliverBigger />
         <TechnologiesList />
         <DefinesUsSection />
         <ClientsPartnersSection />
         <section className="section appreciation-slider-section page_top_section section_theme_2_bg">
            <WordsOfAppreciation />
         </section>
         <WhyChooseUs />
         <BlogSection />
         <ContactUsForm />
      </div>
   )
}
